var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	87539: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(6865), __webpack_require__.e(1817), __webpack_require__.e(2260), __webpack_require__.e(2076), __webpack_require__.e(7580)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	46909: {
		fallback: () => (Promise.all([__webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(1516), __webpack_require__.e(3766), __webpack_require__.e(845)]).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=7.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	42777: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(316)]).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	97582: {
		fallback: () => (Promise.all([__webpack_require__.e(2777), __webpack_require__.e(9291), __webpack_require__.e(4967), __webpack_require__.e(436)]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	25735: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(6865), __webpack_require__.e(2777), __webpack_require__.e(4456)]).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	23905: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 8513))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	43137: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 36699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	76255: {
		fallback: () => (Promise.all([__webpack_require__.e(2645), __webpack_require__.e(1817), __webpack_require__.e(2260), __webpack_require__.e(3895)]).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	62013: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(6865), __webpack_require__.e(6255), __webpack_require__.e(2531)]).then(() => (() => (__webpack_require__(/*! @angular/fire */ 12531))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire",

	},
	1729: {
		fallback: () => (Promise.all([__webpack_require__.e(2615), __webpack_require__.e(9398), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! @angular/fire/compat */ 48942))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire/compat",

	},
	85051: {
		fallback: () => (__webpack_require__.e(1299).then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 63680))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/bidi",

	},
	13277: {
		fallback: () => (__webpack_require__.e(1608).then(() => (() => (__webpack_require__(/*! @angular/cdk/private */ 9227))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/private",

	},
	40527: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(2777), __webpack_require__.e(7912)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 87912))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/layout",

	},
	50489: {
		fallback: () => (__webpack_require__.e(4879).then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 74879))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/keycodes",

	},
	38203: {
		fallback: () => (__webpack_require__.e(9168).then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/portal",

	},
	15599: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(2777), __webpack_require__.e(7582), __webpack_require__.e(5642), __webpack_require__.e(8657), __webpack_require__.e(8513)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/a11y",

	},
	99553: {
		fallback: () => (Promise.all([__webpack_require__.e(2645), __webpack_require__.e(2777), __webpack_require__.e(9975), __webpack_require__.e(1516), __webpack_require__.e(9168), __webpack_require__.e(8500), __webpack_require__.e(2076), __webpack_require__.e(1567)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/overlay",

	},
	65299: {
		fallback: () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(2973)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/coercion",

	},
	70781: {
		fallback: () => (Promise.all([__webpack_require__.e(2777), __webpack_require__.e(2076), __webpack_require__.e(8402)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 17699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/platform",

	},
	97485: {
		fallback: () => (Promise.all([__webpack_require__.e(2777), __webpack_require__.e(9975), __webpack_require__.e(1419)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 79975))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/scrolling",

	},
	68395: {
		fallback: () => (__webpack_require__.e(5129).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers/private */ 65129))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/observers/private",

	},
	55443: {
		fallback: () => (Promise.all([__webpack_require__.e(2645), __webpack_require__.e(2777), __webpack_require__.e(7582), __webpack_require__.e(9975), __webpack_require__.e(1516), __webpack_require__.e(9168), __webpack_require__.e(8500), __webpack_require__.e(5642), __webpack_require__.e(3482)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/dialog */ 93482))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/dialog",

	},
	82805: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(7989)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 37989))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/collections",

	},
	59933: {
		fallback: () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(3197)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/accordion */ 9180))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/accordion",

	},
	47389: {
		fallback: () => (__webpack_require__.e(1920).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 39539))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/observers",

	},
	79291: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(7354)]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	43631: {
		fallback: () => (__webpack_require__.e(9940).then(() => (() => (__webpack_require__(/*! @angular/cdk/text-field */ 69940))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/text-field",

	},
	4217: {
		fallback: () => (Promise.all([__webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(2777), __webpack_require__.e(9975), __webpack_require__.e(5969)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/table */ 90198))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/table",

	},
	34053: {
		fallback: () => (Promise.all([__webpack_require__.e(5735), __webpack_require__.e(8657), __webpack_require__.e(4315)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/stepper */ 63985))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/stepper",

	},
	24547: {
		fallback: () => (__webpack_require__.e(655).then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",

	},
	45261: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(2777), __webpack_require__.e(7582), __webpack_require__.e(5072)]).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	14133: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(6255), __webpack_require__.e(1383)]).then(() => (() => (__webpack_require__(/*! @ngrx/store */ 81383))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store",

	},
	28707: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(5051), __webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(3277), __webpack_require__.e(7582), __webpack_require__.e(9291), __webpack_require__.e(3840), __webpack_require__.e(9706)]).then(() => (() => (__webpack_require__(/*! @angular/material/icon */ 93840))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/icon",

	},
	11614: {
		fallback: () => (__webpack_require__.e(8842).then(() => (() => (__webpack_require__(/*! @onesource/angular/components/core */ 28842))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/angular/components/core",

	},
	38019: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(527), __webpack_require__.e(6781), __webpack_require__.e(5599), __webpack_require__.e(5299), __webpack_require__.e(781), __webpack_require__.e(4175), __webpack_require__.e(7690)]).then(() => (() => (__webpack_require__(/*! @angular/material/button */ 84175))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/button",

	},
	97940: {
		fallback: () => (Promise.all([__webpack_require__.e(527), __webpack_require__.e(1229), __webpack_require__.e(2444)]).then(() => (() => (__webpack_require__(/*! @onesource/angular/configuration */ 52444))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/angular/configuration",

	},
	65903: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3777)]).then(() => (() => (__webpack_require__(/*! @angular/material/card */ 53777))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/card",

	},
	30720: {
		fallback: () => (__webpack_require__.e(299).then(() => (() => (__webpack_require__(/*! @onesource/foundation/icons */ 10299))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=3.3.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/foundation/icons",

	},
	66747: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(5051), __webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(3277), __webpack_require__.e(527), __webpack_require__.e(6781), __webpack_require__.e(8203), __webpack_require__.e(5599), __webpack_require__.e(9553), __webpack_require__.e(5299), __webpack_require__.e(781), __webpack_require__.e(4175), __webpack_require__.e(5262)]).then(() => (() => (__webpack_require__(/*! @angular/material/snack-bar */ 3347))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/snack-bar",

	},
	47191: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(527), __webpack_require__.e(1134)]).then(() => (() => (__webpack_require__(/*! @angular/material/progress-spinner */ 41134))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/progress-spinner",

	},
	21229: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(5051), __webpack_require__.e(2645), __webpack_require__.e(3277), __webpack_require__.e(6781), __webpack_require__.e(489), __webpack_require__.e(8203), __webpack_require__.e(5599), __webpack_require__.e(9553), __webpack_require__.e(5299), __webpack_require__.e(781), __webpack_require__.e(2805), __webpack_require__.e(7485), __webpack_require__.e(5735), __webpack_require__.e(8395), __webpack_require__.e(423), __webpack_require__.e(284), __webpack_require__.e(7389), __webpack_require__.e(4175), __webpack_require__.e(762), __webpack_require__.e(5575), __webpack_require__.e(5175), __webpack_require__.e(743)]).then(() => (() => (__webpack_require__(/*! @angular/material/paginator */ 24624))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/paginator",

	},
	47815: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @sbg/web/log */ 33798))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=6.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@sbg/web/log",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"489": [
		50489
	],
	"527": [
		40527
	],
	"720": [
		30720
	],
	"781": [
		70781
	],
	"1229": [
		21229
	],
	"1729": [
		1729
	],
	"2260": [
		23905,
		43137
	],
	"2777": [
		42777
	],
	"2805": [
		82805
	],
	"3277": [
		13277
	],
	"3631": [
		43631
	],
	"4133": [
		14133
	],
	"4217": [
		4217
	],
	"4547": [
		24547
	],
	"5051": [
		85051
	],
	"5261": [
		45261
	],
	"5299": [
		65299
	],
	"5443": [
		55443
	],
	"5599": [
		15599
	],
	"5735": [
		25735
	],
	"5903": [
		65903
	],
	"6255": [
		76255
	],
	"6622": [
		34053
	],
	"6747": [
		66747
	],
	"6909": [
		46909
	],
	"7191": [
		47191
	],
	"7389": [
		47389
	],
	"7485": [
		97485
	],
	"7539": [
		87539
	],
	"7582": [
		97582
	],
	"7595": [
		97940
	],
	"7756": [
		11614
	],
	"7815": [
		47815
	],
	"8019": [
		38019
	],
	"8203": [
		38203
	],
	"8395": [
		68395
	],
	"8707": [
		28707
	],
	"9291": [
		79291
	],
	"9322": [
		59933
	],
	"9398": [
		62013
	],
	"9553": [
		99553
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}